<template>
  <div>
    <v-card max-width="940" class="mx-auto  my-2">
      <v-card-title>
        <h2>بيانات الحساب</h2>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            disabled
            v-model="email"
            prepend-icon="mdi-email"
            label="الايميل"
          />

          <v-text-field
            v-model="fullName"
            prepend-icon="mdi-account-box"
            label="الاسم"
          />

          <div dir="ltr">
            <VuePhoneNumberInput
              :only-countries="countriesList"
              v-model="phone"
              default-country-code="KW"
              :translations="translations"
            />
          </div>
        </v-form>
        <v-alert v-if="showError" type="error"> خطأ </v-alert>
      </v-card-text>
      <v-card-actions justify-center>
        <v-btn @click="saveChanges" :loading="isSaving" color="success" block
          >حفظ التعديلات</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "AccountInfoComponent",

  //********************** */
  components: {
    VuePhoneNumberInput,
  },

  //********************** */
  data: () => ({
    isSaving: false,
    showError: false,
    fullName: "",
    phone: "",
    email: "",
    countryCode: "",
    translations: {
      countrySelectorLabel: "الدولة",
      countrySelectorError: "يرجى اختيار الدولة",
      phoneNumberLabel: "رقم الهاتف",
    },
    countriesList: ["KW", "SA", "BH", "OM", "QA", "AE"],
  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      customerInfo: "customerInfo",
    }),
  },

  //********************** */
  methods: {
    loadCustomerInfo: async function () {
      this.isLoading = true;
      try {
        await this.$store.dispatch("Account/loadCustomerInfo");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoading = false;
      this.fullName = this.customerInfo.fullName;
      this.phone = this.customerInfo.phone;
      this.email = this.customerInfo.email;
    },
    saveChanges: async function () {
      this.isSaving = true;
      try {
        let model = {
          name: this.fullName,
          phone: this.phone,
        };
        await this.$store.dispatch("Account/updateCustomerInfo", model);
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isSaving = false;
    },
    onUpdate: function (payload) {
      this.countryCode = payload.countryCode;
    },
  },

  //*********************** */
  async mounted() {
    await this.loadCustomerInfo();
  },
};
</script>

<style>
</style>